import AnalysysAgent from "AnalysysAgent";

import { App, inject, reactive } from "vue";

let appKey = "e3b3debf53b4c002";

if (process.env.VUE_APP_ENV === "pro") {
  // 测试环境key
  appKey = "6b5f53fc1a83e802"; // 易观UDP测试appKey
}

export function useAnalysysAgent() {
  return inject(appKey);
}

export const analysInfo = reactive<{
  AnalysysAgent: any;
  hasAlias: boolean;
}>({
  AnalysysAgent: null,
  hasAlias: false,
});

export default {
  install(app: App) {
    AnalysysAgent.init({
      appkey: appKey,
      uploadURL: "https://sdk.homedo.com",
      debugMode: 2,
      auto: false,
      autoTrack: false,
    });

    AnalysysAgent.registerSuperProperty("platform_extra", "PC");
    analysInfo.AnalysysAgent = AnalysysAgent;
    app.provide(appKey, analysInfo);
    app.config.globalProperties.$AnalysysAgent = AnalysysAgent;
  },
};
